import { useRestPost, UseRestPostMutationOptions } from 'scbk-services';
import { APIS } from 'scbk-shared-module/constants/apiPaths';
import { AutSetCodListRequest, AutSetCodListResponse } from '../../types/api/autSetCodList';

/**
 * 코드목록 조회
 * @param mutationOptions
 * @returns
 */
export function useAutSetCodList(
    mutationOptions?: UseRestPostMutationOptions<AutSetCodListRequest, AutSetCodListResponse>,
) {
    return useRestPost<AutSetCodListRequest, AutSetCodListResponse>(
        {
            endpoint: APIS.utilities.settings.code.list,
        },
        mutationOptions,
    );
}
